export default {
    config: {
        defaultWidth: 80
    },
    default: {
        label: 'Year'
    },
    unique: [],
    sort: 'year',
    lang: {
        name: 'Year Published',
        category: 'Game',
        description: 'The year a game was published.',
        views: ['list', 'sheet', 'grid'],
    },
    filters: ['year.published']
}